export default {
  brpSettings: {},
  prpSettings: {},
  noDefaultBrpSetting: true,
  noDefaultPrpSetting: true,
  status: {},
};